// components/portal/HeadlineStats.tsx
'use client';

import React from 'react';
import clsx from 'clsx';

export interface HeadlineStat {
  value: string;
  label: string;
  /** Optional qualifier, said after the label in a quieter grey (e.g. a declared-vs-real delta). */
  sub?: string | null;
}

// THE SUMMARY IS ONE QUIET LINE (owner, 2026-09-30: 'eradicate this component each time you find it
// and replace it with a clever /chatgptize-d equivalent'). The old strip stacked a 20px figure over
// a label in hairline-divided cells, a dashboard band ChatGPT never draws. ChatGPT says figures in
// a sentence: '357 credits this period · 357 Studio', the number in white, the rest in grey, the
// items separated by a middle dot, wrapping instead of scrolling sideways. Every caller (entity
// headers, the inventory metrics bar, Activity, Teams) gets it from here.
export function HeadlineStats({
  stats,
  className,
}: {
  stats: HeadlineStat[];
  className?: string;
}) {
  if (stats.length === 0) return null;
  return (
    <p className={clsx('m-0 flex flex-wrap items-baseline gap-x-2 gap-y-1 text-[#8E8E8E]', className)} style={{ fontSize: 14, lineHeight: '20px' }}>
      {stats.map((s, i) => (
        <React.Fragment key={s.label}>
          {i > 0 ? <span aria-hidden className="text-[#5E5E5E]" style={{ fontSize: 'inherit' }}>·</span> : null}
          <span className="whitespace-nowrap" style={{ fontSize: 'inherit' }}>
            <span className="font-medium tabular-nums text-[#ECECEC]" style={{ fontSize: 'inherit' }}>{s.value}</span>{' '}{s.label}
            {s.sub ? <span className="text-[#6E6E6E]" style={{ fontSize: 'inherit' }}> ({s.sub})</span> : null}
          </span>
        </React.Fragment>
      ))}
    </p>
  );
}
